import { ChillerLog } from '../../model';
import { isRequiredFieldEmpty } from '../../../utils/highlightedDataUtil';

// A "grid" here is a Cell[][] (react-spreadsheet data), e.g. chillerLog.header_details.
const gridHasEmptyCell = (grid: any): boolean => {
  if (!grid) return false;

  return grid.some((row) => row?.some((cell) => isRequiredFieldEmpty(cell?.value)));
};

// Checks only the current log's own data (never prevChillerLog1/prevChillerLog2), and only the
// sections/circuits/compressors that are actually rendered for the technician to edit.
export const hasIncompleteRequiredFields = (chillerLog: ChillerLog): boolean => {
  if (!chillerLog) return false;

  if (gridHasEmptyCell(chillerLog.header_details)) return true;
  if (gridHasEmptyCell(chillerLog.additional_details)) return true;

  const showManufacturerDetailsSection = (chillerLog.manufacturer_details?.length ?? 0) > 1;
  if (showManufacturerDetailsSection && gridHasEmptyCell(chillerLog.manufacturer_details)) return true;

  const showYorkCircuitSection = (chillerLog.circuits?.[0]?.york_circuit_details?.length ?? 0) > 1;

  const circuitsToDisplay = chillerLog.circuits?.slice(0, chillerLog.circuit_count ?? 1) ?? [];

  return circuitsToDisplay.some((circuit) => {
    if (gridHasEmptyCell(circuit?.evaporator_details)) return true;
    if (gridHasEmptyCell(circuit?.condenser_details)) return true;
    if (showYorkCircuitSection && gridHasEmptyCell(circuit?.york_circuit_details)) return true;

    const includedCompressors = circuit?.compressors?.filter((compressor) => compressor.included) ?? [];
    return includedCompressors.some((compressor) => gridHasEmptyCell(compressor?.compressor_details));
  });
};
